'use client';

import { useEffect } from 'react';
import { useParams, useRouter, useSearchParams } from 'next/navigation';
import { PUBLIC_ROUTES } from '@/configs/routes';

/** `/{societyCode}` with no sub-path → society Animal Enquiry (canonical DB search landing). */
export default function SocietyDefaultRedirect() {
  const router = useRouter();
  const params = useParams<{ orgName: string }>();
  const searchParams = useSearchParams();

  useEffect(() => {
    const org = params.orgName?.trim();
    if (!org) return;

    const qs = searchParams.toString();
    const href = qs
      ? `/${org}${PUBLIC_ROUTES.ANIMAL}?${qs}`
      : `/${org}${PUBLIC_ROUTES.ANIMAL}`;

    if (
      typeof window !== 'undefined' &&
      `${window.location.pathname}${window.location.search}` !== href
    ) {
      router.replace(href);
    }
  }, [router, params.orgName, searchParams]);

  return null;
}
